/*
      ##    #######   ##     ##  ########   ########   ##    ##   
      ##   ##     ##  ##     ##  ##         ##     ##   ##  ##    
      ##   ##     ##  ##     ##  ##         ##     ##    ####     
      ##   ##     ##  ##     ##  ######     ########      ##      
##    ##   ##  ## ##  ##     ##  ##         ##   ##       ##      
##    ##   ##    ##   ##     ##  ##         ##    ##      ##      
 ######     ##### ##   #######   ########   ##     ##     ##      
*/

$(document).ready(function() {

	FastClick.attach(document.body);

	$('[data-link]').click(function() {
		window.location.href = $(this).attr('data-link');
	}).find('a').click(function(e) {
		e.stopPropagation();
	});

	/**
	 * Test si les Media Queries sont supportées
	 * Ajoute la classe 'mq' au tag HTML si c'est le cas
	 */
	if ( Modernizr.mq('only all') ) {
		jQuery('html').addClass('mq');
	} else {
		jQuery('html').addClass('no-mq');
	}


	/**
	 * MatchHeight [GRID]
	 */
	$(".harmonize").matchHeight();

	

/*
   ###     ##    ##    ######    ####  ########   ##    ##    ######          ######     ######    ########   ####  ########   ########    ######    
  ## ##    ###   ##   ##    ##    ##   ##         ###   ##   ##    ##        ##    ##   ##    ##   ##     ##   ##   ##     ##     ##      ##    ##   
 ##   ##   ####  ##   ##          ##   ##         ####  ##   ##              ##         ##         ##     ##   ##   ##     ##     ##      ##         
##     ##  ## ## ##   ##          ##   ######     ## ## ##    ######          ######    ##         ########    ##   ########      ##       ######    
#########  ##  ####   ##          ##   ##         ##  ####         ##              ##   ##         ##   ##     ##   ##            ##            ##   
##     ##  ##   ###   ##    ##    ##   ##         ##   ###   ##    ##        ##    ##   ##    ##   ##    ##    ##   ##            ##      ##    ##   
##     ##  ##    ##    ######    ####  ########   ##    ##    ######          ######     ######    ##     ##  ####  ##            ##       ######    
*/

	// ZOOM
	$("a.zoom").fancybox(); 
	
	// SLIDER	
	current = 0;
	var Slider = function(){		
		$this = $("#slider li:eq("+current+")");
		// referme tous autres + enlève les classes selected
		$("#slider div.contenu").not( $this.find("div.contenu") ).slideUp();
		$("#slider li a").removeClass('selected');
		
		// ouvre le bon + ajoute la classe selected
		$this.find("div.contenu").slideDown();
		$this.find("a").addClass('selected');
		
		$("#slider .photos img").each(function() {
			if($(this).index() != current) $(this).fadeOut();
		});
		$("#slider .photos img:eq("+current+")").fadeIn();
	};
		
	$("#slider li").hover(
		function() {
			current = $(this).index();
			$("#slider").stopTime("Timers");
			Slider(current);
		},
		function() {
			i = $(this).index();
			//$(this).find("div.contenu").slideUp();
		}
	);
	
	// auto-slide
	Slider();
	$("#slider").everyTime(5000, 'Timers', function() {
		current++;
		if(current > 3) current = 0;
	 	Slider();
	});
	
	// FORMULAIRE DEVIS
	$("#ContactForm").validationEngine();	
	$("#ContactForm").submit(function(){
		if($("#ContactForm").validationEngine('validate')){
			var div = $('.formulaire').html("<p>Message en cours d'envoi...</p>");
			var data = $(this).serialize() + '&act=envoi';
			$.ajax({
				type: "POST",
				data : data,
				url: window.location.href,
				success: function(retour) {
					div.html("<p>"+retour+"</p>");
				}
			});
		}
		return false;
	});

	// MAPS
	if($('#map_canvas').length > 0)
		initialize('fr', 45.762023, 4.775711);


});
